// extracted by mini-css-extract-plugin
export default {"company":"company_company__O1haQ","company_heading":"company_company_heading__qOom9","add_btn":"company_add_btn__z1A4G","cards":"company_cards__81UyX","card":"company_card__z42Ib"};